<div id="content animation-fade-in">
  <div class="heading">
    <h3>Your Orders</h3>
  </div>

  <order-list-tabs></order-list-tabs>
</div>

<shared-navigation-main-mobile></shared-navigation-main-mobile> 